<template>
  <div>
    <andes-header></andes-header>

    <div class="container payment-page">
      <div class="row">
        <div class="col-sm-9">

          <div class="row">
            <div class="col-12">
              <div class="current-srch-container">
                <div class="row d-flex align-items-center text-center text-sm-left">
                  <div class="col-12 col-sm-6 ">
                    <h4 class="payment-title m-0">{{ $t('REALIZAR PAGO PENDIENTE') }}</h4>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="reservation text-center">{{ $t('Reserva:') }} {{ booking.RecordLocator }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="itin">
            <payment-summary class="mb-3"></payment-summary>
          </div>

          <div class="card shadow mt-3" v-if="booking.BalanceDue > 0">
            <div class="card-body">
              <h3 class="total-title">{{ $t('TOTAL A PAGAR:') }}  <span>ARS {{toCurrencyFormat(booking.BalanceDue)}}</span></h3>
              <hr/>
              <p class="text-muted mb-3" v-if="afterPaymentRoute === 'checkinreview'">
                Este pago corresponde al cargo de asiento. Cuando se acredite, vas a continuar con el check-in.
              </p>
              <div class="d-flex justify-content-between align-items-center flex-wrap p-2">
                <button type="button" class="btn btn-andes mb-2" :disabled="loading" @click="backToItinerary">
                  {{ $t('Volver al itinerario') }}
                </button>
                <button type="button" class="btn btn-andes mb-2" :disabled="loading" @click="onContinue">{{ $t('Pagar') }}</button>
              </div>
              <p class="text-danger mb-0" v-if="error">{{ $t(error) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-if="loading"></loading-modal>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import AndesHeader from "../components/AndesHeader";
  import LoadingModal from "../components/LoadingModal";
  import PaymentSummary from "../components/itinerary/PaymentSummary";
  import { formatMoney } from "../utils/utils";
  import { makePaymentV2 } from '@/api/api';
  var moment = require('moment');

  export default {
    components: {
      PaymentSummary,
      LoadingModal,
      AndesHeader,
    },
    name: 'pending-payment-page',
    computed: {
      ...mapState(['booking', 'loading', 'afterPaymentRoute', 'checkinFlight']),
      paymentSegment: function () {
        if (this.checkinFlight && this.checkinFlight.Legs && this.checkinFlight.Legs[0]) {
          let leg = this.checkinFlight.Legs[0];
          let inv = leg.InventoryLeg || leg;
          return {
            DepartureStation: this.checkinFlight.DepartureStation || inv.DepartureStation,
            ArrivalStation: this.checkinFlight.ArrivalStation || inv.ArrivalStation,
            STD: inv.STD,
            STA: inv.STA,
          };
        }
        let pax = this.booking && this.booking.Passengers && this.booking.Passengers[0];
        let seg = pax && pax.Segments && pax.Segments[0];
        let leg = seg && seg.Legs && seg.Legs[0];
        let inv = leg && leg.InventoryLeg;
        if (!seg || !inv) return null;
        return {
          DepartureStation: seg.DepartureStation,
          ArrivalStation: seg.ArrivalStation,
          STD: inv.STD,
          STA: inv.STA,
        };
      },
    },
    data: function () {
      return {
        error: null,
      };
    },
    methods: {
      backToItinerary: function () {
        this.$store.commit('ancillaryFromItinerary', false);
        this.$store.commit('loading', false);
        this.$router.replace('itinerary');
      },
      onContinue: async function () {
        this.error = null;
        if (parseFloat(this.booking.BalanceDue || 0) <= 0) {
          let next = this.afterPaymentRoute || 'itinerary';
          this.$store.commit('afterPaymentRoute', null);
          this.$router.replace(next);
          return;
        }
        if (!this.paymentSegment) {
          this.error = this.$t('No se pudo obtener el vuelo para iniciar el pago.');
          return;
        }
        const staUTC = moment(this.paymentSegment.STA).utc().format();
        const stdUTC = moment(this.paymentSegment.STD).utc().format();
        this.$store.commit('loading', true);
        await makePaymentV2(
          this.booking,
          this.paymentSegment.DepartureStation,
          this.paymentSegment.ArrivalStation,
          staUTC,
          stdUTC,
          (response) => {
            if (response && response.URL) {
              window.location.href = response.URL;
              return;
            }
            this.$store.commit('loading', false);
            this.error = (response && response.message) || this.$t('Error al procesar el pago. Intente nuevamente.');
          }
        );
      },
      toCurrencyFormat: function (amount) {
        return formatMoney(amount);
      },
    },
    mounted() {
      this.$store.commit('loading', false);
      if (_.isEmpty(this.booking)) {
        this.$router.replace('/');
        return;
      }
      if (parseFloat(this.booking.BalanceDue || 0) <= 0 && this.afterPaymentRoute) {
        let next = this.afterPaymentRoute;
        this.$store.commit('afterPaymentRoute', null);
        this.$router.replace(next);
      }
    },
  }
</script>
